import React from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Payment from '../pages/Payment';


const MainRoute = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Payment />} />
            </Routes>
        </BrowserRouter>
    )
}

export default MainRoute